module.exports = __webpack_public_path__ + "static/media/patientnow.89b4cd30.png";